import articleHasChannelDates from "../../distribution/articleHasChannelDates";
import { channelSupportsArticle } from "../../distribution/utils/deliverArticlesToChannels";

import articleDeliveryStatuses from "../constants/articleDeliveryStatuses";

export default function applyArticleDistributionChannelDeliveryData({ article, channel, disableDeliveryNeeded }) {
	return {
		delivery: {
			metadata: {
				status: channelSupportsArticle({
					article,
					channel,
					deliveryType: "metadata",
				})
					? disableDeliveryNeeded ||
					  !articleHasChannelDates(article, channel.id) ||
					  (!article.artifact?.ref && !!channel.forceDeliveryOfMetadataAndFilesSimultaneously)
						? articleDeliveryStatuses.DELIVERY_NOT_STARTED
						: articleDeliveryStatuses.DELIVERY_NEEDED
					: articleDeliveryStatuses.DELIVERY_UNSUPPORTED,
			},
			artifact: {
				status: channelSupportsArticle({
					article,
					channel,
					deliveryType: "artifact",
				})
					? article.artifact?.ref && !disableDeliveryNeeded
						? articleDeliveryStatuses.DELIVERY_NEEDED
						: articleDeliveryStatuses.DELIVERY_NOT_STARTED
					: articleDeliveryStatuses.DELIVERY_UNSUPPORTED,
			},
		},
	};
}
